export type TDimension = number | 'default'
export const IMAGE_KIT_LINK = 'imagekit.io'
export const DEFAULT_IMAGE_DIMENSION = 'default'

export const getImageByDimensions = (
  url: string,
  width: TDimension = DEFAULT_IMAGE_DIMENSION,
  height: TDimension = DEFAULT_IMAGE_DIMENSION
) => {
  if (url.includes(IMAGE_KIT_LINK)) {
    return url.replace(new RegExp('h-\\w+'), `h-${height}`).replace(new RegExp('w-\\w+'), `w-${width}`)
  }
  return url
}
